import "./styles.css";

const ActionButton = ({ text, type, handleClick }) => {
  return (
    <button
      className={`actionBtnContainer shadow ${
        type === "outline"
          ? "actionBtnContainerOutline"
          : "actionBtnContainerFilled"
      }`}
      onClick={() => {
        handleClick();
      }}
    >
      {text}
    </button>
  );
};

export default ActionButton;
